import React from 'react';

import DefaultBPIcon from '../../../../../assets/icons/DefaultBPIcon';
import {
  BPDetailsWrapper,
  BPItem,
  BPListWrapper,
  IconWrapper,
} from '../styles';
import { BusinessPartnerSelectorItem } from '../types';
import LockIcon from '../../../../../assets/icons/LockIcon';

export type BusinessPartnerSelectionListProps = {
  onBPSelect: (businessPartner: BusinessPartnerSelectorItem) => void;
  bpItems: BusinessPartnerSelectorItem[];
  isListOpen: boolean;
};

const BusinessPartnerSelectionList: React.FC<
  BusinessPartnerSelectionListProps
> = ({ onBPSelect, bpItems, isListOpen }) => {
  const handleKeyDown = (
    event: React.KeyboardEvent,
    bp: BusinessPartnerSelectorItem
  ) => {
    if (event.key === 'Enter') {
      onBPSelect(bp);
    }
  };

  return (
    <BPListWrapper isListOpen={isListOpen}>
      <ul>
        {bpItems.map((bp) => (
          <BPItem
            key={bp.businessPartnerNumber}
            onClick={() => onBPSelect(bp)}
            onKeyDown={(event) => handleKeyDown(event, bp)}
            tabIndex={0}
          >
            <IconWrapper>
              <DefaultBPIcon color={bp.inactive ? 'grey' : undefined} />
            </IconWrapper>
            <BPDetailsWrapper>
              <span>{bp.businessPartnerNumber}</span>
              <span>{bp.businessPartnerDisplayName}</span>
            </BPDetailsWrapper>
            {bp.inactive && <LockIcon />}
          </BPItem>
        ))}
      </ul>
    </BPListWrapper>
  );
};

export default BusinessPartnerSelectionList;
